import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { BooleanApiResponse } from '@/types/mySettlementDeleted';

type QueryType = {
  oidLiquidacion: number[];
};

export const deleteSettlementByOID = async (
  query: QueryType
): Promise<boolean> => {
  try {
    const promises = query.oidLiquidacion.map((oidLiquidacion) =>
      apiClient.post<BooleanApiResponse>(Endpoints.deletedMySettlement, {
        oidLiquidacion,
      })
    );

    const res = await Promise.all(promises);

    return !!res[0].data.value;
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      if (error.response.status === 404) {
        throw new Error('Invalid Data');
      } else {
        throw new Error(error.message);
      }
    } else {
      throw error;
    }
  }
};
